import type { GroupLifeTarifacaoLife } from '@/services/group-life';

const MONTHS_IN_YEAR = 12;

const toCents = (value: number) => Math.round(value * 100) / 100;

/** Converte um prêmio ANUAL (vindo do InsureMO) para MENSAL, em centavos. */
export function annualToMonthly<T extends number | null>(
  value: T
): T extends number ? number : null {
  return (
    value == null ? null : toCents(value / MONTHS_IN_YEAR)
  ) as T extends number ? number : null;
}

export type MonthlyLifeTotals = {
  net: number;
  iof: number;
  due: number;
};

/**
 * Totais MENSAIS da vida para o grid da tarifação: total anual da vida ÷ 12 —
 * mesma conta do `SummaryLivesGrid` (resumos da cotação e da proposta), para
 * as duas telas exibirem o mesmo valor. A linha da vida pode diferir em 1
 * centavo da soma das coberturas, como no resumo.
 */
export function monthlyLifeTotals(life: GroupLifeTarifacaoLife): MonthlyLifeTotals {
  return {
    net: annualToMonthly(life.totalNetPremium),
    iof: annualToMonthly(life.totalIof),
    due: annualToMonthly(life.totalDuePremium),
  };
}
